import axios from "axios";
import Cookies from "js-cookie";

const BASE_URL = process.env.REACT_APP_BASE_URL_SERVER;

const API = axios.create({
  baseURL: BASE_URL,
});

API.interceptors.request.use(
  function (config) {
    let token;
    if (Cookies.get("token")) {
      token = Cookies.get("token");
    }
    config.headers.authorization = `${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

//adminlogin
API.adminLogin = (data) => {
  return API.post("admin/login", data);
};

API.changePassword = (data) => {
  return API.patch("admin/change-password", data);
};

API.updateProfile = (id, data) => {
  return API.patch(`admin/${id}`, data);
};

// exam
API.getAllExams = () => {
  return API.get("exam");
};
API.updateExam = (id, data) => {
  return API.patch(`exam/${id}`, data);
};

API.addExam = (data) => {
  return API.post("exam", data);
};

API.getSingleExam = (id) => {
  return API.get(`exam/${id}`);
};

// recall
API.getAllRecalls = () => {
  return API.get("recall");
};

API.getSingleRecall = (id) => {
  return API.get(`recall/${id}`);
};

API.addRecall = (data) => {
  return API.post("recall", data);
};

API.updateRecall = (id, data) => {
  return API.patch(`recall/${id}`, data);
};

//Category

API.getAllCategories = () => {
  return API.get("category");
};

API.getSingleCategorey = (id, data) => {
  return API.patch(`category/${id}`, data);
};

API.createCategory = (data) => {
  return API.post("category", data);
};

API.updateCategory = (id, data) => {
  return API.patch(`category/${id}`, data);
};


//Category Recall

API.getAllCategoriesRecall = () => {
  return API.get("category-recall");
};

API.getSingleCategoreyRecall = (id, data) => {
  return API.patch(`category-recall/${id}`, data);
};

API.createCategoryRecall = (data) => {
  return API.post("category-recall", data);
};

API.updateCategoryRecall = (id, data) => {
  return API.patch(`category-recall/${id}`, data);
};

// Promo
API.getAllPromo = () => {
  return API.get("promo");
};
API.addPromo = (data) => {
  return API.post("promo", data);
};
API.updatePromo = (id, data) => {
  return API.patch(`promo/${id}`, data);
};

// Promo Recall
API.getAllPromoRecall = () => {
  return API.get("promo-recall");
};
API.addPromoRecall = (data) => {
  return API.post("promo-recall", data);
};
API.updatePromoRecall = (id, data) => {
  return API.patch(`promo-recall/${id}`, data);
};

// blogs

API.getAllBlogs = () => {
  return API.get("blog");
};

API.getSingleBlog = (id) => {
  return API.get(`blog/${id}`);
};

API.createBlogs = (data) => {
  return API.post("blog", data);
};

API.updateBlogs = (id, data) => {
  return API.patch(`blog/${id}`, data);
};

API.deleteBlogs = (id) => {
  return API.delete(`blog/${id}`);
};

//users
API.registerUser = (data) => {
  return API.post("user", data);
};

API.deleteUser = (id) => {
  return API.delete(`user/${id}`);
};

//MembersManagement
API.getAllUsers = () => {
  return API.get("user");
};

API.getSingleUsers = (id) => {
  return API.get(`user/${id}`);
};

API.getAllSubscribedMembers = () => {
  return API.get("user/subscription");
};
API.registerUserSubscription = (data) => {
  return API.post("user/subscription", data);
};
API.getSingleSubscribedMembers = (id) => {
  return API.get(`user/subscription/${id}`);
};
API.updateUserSubscription = (id, data) => {
  return API.patch(`user/subscription/${id}`, data);
};

API.createuser = (data) => {
  return API.post("user/by-admin", data);
};

API.updateUser = (data) => {
  return API.patch(`user/by-admin`, data);
};

//adming
// API.updateUserByAdmin = (data) => {
//   return API.patch(`user`, data);
// };

API.logInUser = (data) => {
  return API.post("user/login", data);
};
API.forgetPassword = (data) => {
  return API.post("user/forget-password", data);
};
API.resetPassword = (data) => {
  return API.post("user/reset-password", data);
};

//subscription
API.getAllSubscription = (data) => {
  return API.get("subscription", data);
};
API.addSubscription = (data) => {
  return API.post("subscription", data);
};
API.updateSubscription = (id, data) => {
  return API.patch(`subscription/${id}`, data);
};

//subscription-recall
API.getAllSubscriptionRecall = (data) => {
  return API.get("subscription-recall", data);
};
API.addSubscriptionRecall = (data) => {
  return API.post("subscription-recall", data);
};
API.updateSubscriptionRecall = (id, data) => {
  return API.patch(`subscription-recall/${id}`, data);
};

//topics
API.getAllTopics = (data) => {
  return API.get("topic", data);
};

API.getCategoryTopics = (id) => {
  return API.get(`/topic/category/${id}`);
};

API.addTopics = (data) => {
  return API.post("topic", data);
};
API.updateTopics = (id, data) => {
  return API.patch(`topic/${id}`, data);
};

//questions
API.getAllQuestion = (data) => {
  return API.get("question", data);
};
API.getQuestionStatistics = () => {
  return API.get("/question/over-all");
};
API.getSingleQuestion = (id) => {
  return API.get(`question/${id}`);
};
API.addQuestion = (data) => {
  return API.post("question", data);
};
API.updateQuestion = (id, data) => {
  return API.patch(`question/${id}`, data);
};

//recall questions
API.getAllQuestionRecall = (data) => {
  return API.get("question-recall", data);
};
API.getQuestionRecallStatistics = () => {
  return API.get("/question-recall/over-all");
};
API.getSingleQuestionRecall = (id) => {
  return API.get(`question-recall/${id}`);
};
API.addQuestionRecall = (data) => {
  return API.post("question-recall", data);
};
API.updateQuestionRecall = (id, data) => {
  return API.patch(`question-recall/${id}`, data);
};


//questions
API.SubscriptionUser = (data) => {
  return API.get("/user/subscription", data);
};
API.SubscriptionRecall = (data) => {
  return API.get("/user/subscription-recall", data);
};

//all country
API.getAllCountry = (data) => {
  return API.get("/country", data);
};

//all feedback
API.getAllFeedBack = () => {
  return API.get("/feedback");
};

API.updatefeedBackStatus = (id, data) => {
  return API.patch(`feedback/${id}`, data);
};

//all feedback
API.getAllFeedBackRecall = () => {
  return API.get("/feedback-recall");
};

API.updatefeedBackStatusRecall = (id, data) => {
  return API.patch(`feedback-recall/${id}`, data);
};

//all reports
API.getAllReports = () => {
  return API.get("/report");
};

API.updateReportStatus = (id, data) => {
  return API.patch(`report/${id}`, data);
};

//all reports Recall
API.getAllReportsRecall = () => {
  return API.get("/report-recall");
};

API.updateReportStatusRecall = (id, data) => {
  return API.patch(`report-recall/${id}`, data);
};

//newsletter
API.getAllNewsletter = () => {
  return API.get("/newsletter");
};

API.uploadImage = (data) => {
  return API.post("/upload", data);
};

//statistics

API.getStatistics = (startDate, endDate, choice) => {
  return API.get(
    `/dashboard?startDate=${startDate}&endDate=${endDate}&choice=${choice}`
  );
};

API.getStatisticsGraph = (selectedRange) => {
  return API.get(`/dashboard/graphs?range=${selectedRange}`);
};

export { API };
